import React from 'react';


export const PlayArrow = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M8.016 5.016l10.969 6.984-10.969 6.984v-13.969z" />
  </svg>);
